(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["starflex-inspiration-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    const link = event.target.closest('[data-sf-inspiration-link]');
    if (!link) return;
    const drawer = link.closest('header-drawer');
    const details = drawer?.querySelector('details');
    if (details?.open) details.querySelector(':scope > summary')?.click();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["starflex-product-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
  const summary=event.target.closest('.sf-product-nav--mobile .sf-product-nav__details>summary');
  if(!summary)return;
  event.stopImmediatePropagation();
  summary.setAttribute('aria-expanded',String(!summary.parentElement.open));
},true);
  } catch(e) { console.error(e); }
})();

})();
